import { render, staticRenderFns } from "./Bip.vue?vue&type=template&id=2514b7f4&scoped=true&"
import script from "./Bip.vue?vue&type=script&lang=js&"
export * from "./Bip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514b7f4",
  null
  
)

export default component.exports